// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__qRS7z","author":"Table_author__GZM39","authorImage":"Table_authorImage__1JMWM","unreadRow":"Table_unreadRow__2nrl6"};